import { colors } from '@omilia/theme';
import styled from 'styled-components';

export const SFormContainer = styled.div`
  background-color: #f0f0f0;
  border-radius: 10px;
  width: 100%;

  form {
    background-color: unset;

    label {
      font-size: 12px;
    }

    input {
      padding-top: 8px;
      font-size: 14px;
      background: ${colors.COLOR_WHITE};
    }
  }

  .form-input + div {
    margin-top: 4px;
    font-size: 11px;
  }
`;
